import { render, staticRenderFns } from "./EmailSendPage.vue?vue&type=template&id=c8625d8a&"
import script from "./EmailSendPage.vue?vue&type=script&lang=js&"
export * from "./EmailSendPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports